import { BrandPalette } from './brand-palette.interface';
import { NavbarPalette } from './navbar-palette.interface';
import { DangerButtonPalette } from './danger-button-palette.interfcae';

export interface Palette {
  brand: BrandPalette;
  navbar: NavbarPalette;
  dangerButton: DangerButtonPalette;
}
